import { Chip, type ChipProps } from "@mui/material";

import { type CrownEnv } from "./env-config";

/**
 * Chip colour per target env, so the same env never appears in two colours
 * across the tool.
 *
 * `prod` is `error` because every destructive action here (bulk import, config
 * migration, piece backfill) is irreversible against live customer data. `demo`
 * gets its own colour rather than sharing the neutral default, because it is
 * persistent and externally visible: prospects may be looking at it, so writing
 * to it by accident is not free the way a dev sandbox is.
 */
const ENV_COLOR: Record<CrownEnv, ChipProps["color"]> = {
  dev: "default",
  demo: "secondary",
  staging: "default",
  release: "default",
  prod: "error",
};

type EnvChipProps = {
  /** The env to label. */
  readonly env: CrownEnv;
  /** Chip size, defaulting to `small` for header use. */
  readonly size?: ChipProps["size"];
};

const EnvChip = ({ env, size = "small" }: EnvChipProps) => (
  <Chip color={ENV_COLOR[env]} label={env.toUpperCase()} size={size} />
);

export default EnvChip;
